import { render, staticRenderFns } from "./Publishers.vue?vue&type=template&id=447ca9dd&scoped=true&"
import script from "./Publishers.vue?vue&type=script&lang=js&"
export * from "./Publishers.vue?vue&type=script&lang=js&"
import style0 from "./Publishers.vue?vue&type=style&index=0&id=447ca9dd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "447ca9dd",
  null
  
)

export default component.exports